import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconStarStyle0 = cosmosIconCss;

const CosmosIconStar = /*@__PURE__*/ proxyCustomElement(class CosmosIconStar extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '84451575f8c4916ee151c48b39e57eebdf27d145', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'dc33c7e945b2ef17957794ba522025183fc1c562', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '035f5fe293f961a44beb74cf74717127f5fc9cd1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.004 5.905 1.526 3.86 3.87.352-3.158 2.79 1.03 3.555-3.268-2.14-3.267 2.14 1.03-3.556-3.163-2.79 3.875-.351 1.526-3.86Zm0-2.905c-.204 0-.346.151-.488.516L8.54 8.51l-4.892.445C3.187 9 3 9.116 3 9.364c0 .178.089.32.329.525l3.922 3.458-1.432 4.942c-.124.453-.017.711.294.711a.852.852 0 0 0 .426-.16l4.465-2.924 4.465 2.924a.88.88 0 0 0 .427.16c.32 0 .426-.267.293-.711l-1.432-4.942 3.914-3.458c.24-.205.329-.347.329-.525 0-.248-.187-.364-.649-.408l-4.883-.445-1.974-4.995c-.152-.374-.285-.516-.49-.516Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconStarStyle0; }
}, [1, "cosmos-icon-star", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-star"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-star":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStar);
            }
            break;
    } });
}

export { CosmosIconStar as C, defineCustomElement as d };
